// extracted by mini-css-extract-plugin
export var bounce = "_jt-1";
export var generatingText = "_jt-6";
export var lightning = "_jt-4";
export var popup = "_jt-5";
export var progressBar = "_jt-7";
export var progressFill = "_jt-8";
export var progressShimmer = "_jt-9";
export var progressText = "_jt-a";
export var shimmer = "_jt-3";
export var uploadIcon = "_jt-0";
export var uploadingText = "_jt-2";